import "./InvestmentKPI.css";

import { OrganisationTypeConstants } from "../../../../constants";
import { useAuth } from "../../../../useAuth";
import { formatNumber } from "../../../../utils";

interface InvestmentKPIProps {
  amount: number | undefined;
  title: string;
}
export const InvestmentKPI = ({ amount, title }: InvestmentKPIProps): JSX.Element => {
  const { currentUserType } = useAuth();
  return (
    <div className="InvestmentKPI">
      <div className="InvestmentKPIHeader">
        <p className="body01">{title}</p>
      </div>
      <div className="InvestmentKPIFooter">
        {currentUserType === OrganisationTypeConstants.DEVELOPER ? (
          <h2 className={`InvestmentKPIAmount ${currentUserType}`}>{formatNumber(amount)}</h2>
        ) : (
          <h1 className={`InvestmentKPIAmount ${currentUserType}`}>{formatNumber(amount)}</h1>
        )}
      </div>
    </div>
  );
};
